import { render } from "./brand_list.vue?vue&type=template&id=731d3aef"
import script from "./brand_list.vue?vue&type=script&lang=js"
export * from "./brand_list.vue?vue&type=script&lang=js"

import "./brand_list.vue?vue&type=style&index=0&id=731d3aef&scope=true&lang=css"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__